import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n';
import messages from './lang';

Vue.config.productionTip = false

// import VuePixi from '@/pixi.js'
// Vue.use(VuePixi)

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'ua',
  fallbackLocale: 'ua',
  messages
});

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#BB')
